module.exports = __webpack_public_path__ + "lxy-admin/img/ewm.517320cf.png";